/**
 * Preserve native navigation while opening external web links in new tabs.
 * @param {Element} link
 */
function openExternalLinkInNewTab(link) {
  if (
    !(link instanceof HTMLAnchorElement) ||
    !['http:', 'https:'].includes(link.protocol) ||
    link.hostname === window.location.hostname
  ) {
    return;
  }

  link.target = '_blank';
  link.relList.remove('opener');
  link.relList.add('noopener');
}

document.querySelectorAll('a[href]').forEach(openExternalLinkInNewTab);

for (const eventName of ['click', 'auxclick', 'contextmenu', 'focusin']) {
  document.addEventListener(eventName, (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (link) openExternalLinkInNewTab(link);
  }, { capture: true });
}
